import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ContenedorComponent } from './components/contenedor.component';
import { InicioGuardService } from './guards/inicio-guard/inicio-guard.service';
import { ClienteGuardService } from './guards/cliente-guard/cliente-guard.service';
import { ContenedorClienteComponent } from './components/cliente/contenedor-cliente/contenedor-cliente.component';
import { RefreshComponent } from './components/shared/refresh/refresh.component';
import { MisNegociosComponent } from './modules/mis-negocios/pages/mis-negocios.component';
import { ForbiddenPageComponent } from './components/shared/forbidden-page/forbidden-page.component';
import { MisClientesComponent } from './modules/mis-clientes/pages/mis-clientes.component';

const APP_ROUTES: Routes = [
    {
        path: '',
        component: ContenedorComponent,
        canActivate: [InicioGuardService],
        runGuardsAndResolvers: 'always',
        children: [
            {
                path: 'Inicio',
                component: HomeComponent,
            },
            {
                path: 'Clientes',
                component: ContenedorClienteComponent,
                canActivate: [ClienteGuardService],
                runGuardsAndResolvers: 'always'
            },
            {
                path: 'RefrshComponent',
                component: RefreshComponent,
            },
            {
                path: 'mis-negocios',
                component: MisNegociosComponent
            },
            {
                path: 'mis-clientes',
                component: MisClientesComponent
            },
            { path: '', pathMatch: 'full', redirectTo: 'Inicio', }
        ]
    },
    {
        path: "forbidden-page",
        component: ForbiddenPageComponent,
    },
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, { useHash: true, onSameUrlNavigation: 'reload' });



// WEBPACK FOOTER //
// ./src/app/app.routes.ts